<template>
  <app-modal
    ref="modal"
    v-bind="$attrs"
    class="modal-container"
    content-class="modal-large"
    title="SASEゲートウェイ選択"
  >
    <template v-slot:body="{ cancel }">
      <v-card-text class="pa-0">
        <div class="modal-body">
          <v-container>
            <v-row>
              <v-col>
                <h3>ゲートウェイタイプを選択</h3>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <div class="mb-1">
                  ゲートウェイのタイプを選択することができます。
                </div>
                <ul class="pl-4">
                  <li>Palo Alto</li>
                </ul>
                <div class="text-caption">
                  ※作成を行ったら料金が発生しますのでご注意ください。
                </div>
              </v-col>
            </v-row>
            <v-row>
              <!-- Palo Alto -->
              <v-col cols="12">
                <v-card variant="outlined" class="h-100">
                  <v-card-text class="text-center">
                    <v-icon
                      icon="$mdiCloudKey"
                      size="50"
                      class="saseGatewayServiceType"
                    />

                    <div class="mt-2 font-weight-bold text-subtitle-1">
                      Palo Alto
                    </div>
                    <div class="text-body-2 mb-2">
                      ネットワーク機能とセキュリティ機能を兼ね備えたクラウドサービス
                    </div>

                    <v-btn
                      class="mt-1 freeBtnStyle"
                      @click="paloAltoRegister"
                      color="primary"
                      :disabled="isPaloAltoButtonDisabled"
                    >
                      Palo Alto作成
                    </v-btn>

                    <ul class="ml-2 mt-2 text-left">
                      <li>
                        オンプレミス機器不要でクラウドから包括的なセキュリティを提供
                      </li>
                      <li>URLフィルタリング、マルウェア対策を一元化</li>
                      <li>
                        残り契約可能数：{{ saseGatewayRemainingContracts }}
                      </li>
                    </ul>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <!-- FOOTER -->
      <v-card-actions>
        <v-list-item class="w-100 pa-1">
          <template v-slot:append>
            <v-btn @click="cancel" variant="outlined" color="primary"
              >戻る</v-btn
            >
          </template>
        </v-list-item>
      </v-card-actions>
    </template>
  </app-modal>
</template>

<script lang="ts">
import type { PropType } from "vue";
import { defineComponent } from "vue";
import { VueFinalModal } from "vue-final-modal";
import SaseGatewayPaloAltoEdit from "@/modals/saseGateway/paloalto/SaseGatewayPaloAltoEdit.vue";
import type { SaseGatewayListEntity } from "@/apis/SaseGatewayApi";

export default defineComponent({
  name: "SaseGatewaySelectType",
  props: {
    paloAltoItems: {
      type: Array as PropType<SaseGatewayListEntity[]>,
      required: true,
    },
    /** KeyID */
    saseGatewayKeyId: {
      type: String as PropType<string>,
      required: true,
    },
    /** VNコネクト帯域値(Mbps) */
    saseGatewayBandwidthUpperLimit: {
      type: Number as PropType<number>,
      required: true,
    },
    /** SASEゲートウェイ残り契約数 */
    saseGatewayRemainingContracts: {
      type: Number as PropType<number>,
      required: true,
      default: 0,
    },
    /** SASEゲートウェイ残り帯域値(Mbps) */
    saseGatewayRemainingBandwidth: {
      type: Number as PropType<number>,
      required: true,
      default: 0,
    },
  },
  computed: {
    /**
     * PaloAlto作成ボタンの活性/非活性を制御
     */
    isPaloAltoButtonDisabled(): boolean {
      // 残り契約数が1未満、または残り帯域が200Mbps未満の場合は非活性にする
      return (
        this.saseGatewayRemainingContracts < 1 ||
        this.saseGatewayRemainingBandwidth < 200
      );
    },
  },
  methods: {
    /**
     * Palo Alto作成
     */
    async paloAltoRegister() {
      await this.$modal.show(SaseGatewayPaloAltoEdit, {
        saseGatewayKeyId: this.saseGatewayKeyId,
        paloAltoItems: this.paloAltoItems,
        saseGatewayBandwidthUpperLimit: this.saseGatewayBandwidthUpperLimit,
        saseGatewayRemainingBandwidth: this.saseGatewayRemainingBandwidth,
      });
      // 子モーダルが正常に閉じられたら、親モーダルも閉じる
      (this.$refs.modal as typeof VueFinalModal & { ok: () => void }).ok();
    },
  },
});
</script>

<style scoped>
.saseGatewayServiceType {
  color: #f5a623;
}
</style>
